import InviraRolesForm from './InviraRolesForm.vue'
export {InviraRolesForm}
export default InviraRolesForm

